module.exports = __webpack_public_path__ + "/images/ico-vendedores-bombilla-euro.8e53386.svg";